import { Box, Dialog, DialogActions, DialogContent, Divider, IconButton, Typography } from "@mui/material"
import { AddOutlined, CheckCircleOutlined, CloseOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"

import { Button } from "@/components/common/Button"
import { FILE_UPLOAD_TAKES_TIME_MESSAGE } from "@/components/upload/constants"

interface PostCreationDialogProps {
  onClose: () => void
  onSuccess: () => void
}

const PostCreationDialog: FC<PostCreationDialogProps> = ({ onClose, onSuccess }) => {
  return (
    <Dialog open onClose={onClose} fullWidth>
      <>
        <IconButton aria-label='close' onClick={onClose} className='absolute right-4 top-4 text-primary'>
          <CloseOutlined />
        </IconButton>
        <Divider />
        <DialogContent classes={{ root: "p-10" }}>
          <Box className='mb-6 w-full justify-center text-center'>
            <CheckCircleOutlined className='size-[48px] text-green-500' />
            <Typography
              data-testid='confirmation-title'
              variant='h5'
              color='primary'
              className='mt-6 font-normal'
              component='h2'
            >
              Certification Successfully Added
            </Typography>
          </Box>
          <Typography
            data-testid='confirmation-content'
            className='mt-6 px-3 text-center text-base leading-[150%] tracking-[-0.85px] text-gray-700'
            component='div'
          >
            Add Another Certification to one or multiple locations, or click on Done to see your progress.
            {FILE_UPLOAD_TAKES_TIME_MESSAGE}
          </Typography>
        </DialogContent>
        <DialogActions className='justify-center px-10 pb-10'>
          <Button appearance='text' onClick={onSuccess}>
            <AddOutlined />
            Add another Certification
          </Button>
          <Button onClick={onClose}>Done</Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

export default PostCreationDialog
